import React, { useCallback, useEffect, useMemo, useState } from "react";
import Close from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CloseIcon from "@mui/icons-material/Close";
import MailIcon from "@mui/icons-material/Mail";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
  CircularProgress,
  Tooltip,
  InputAdornment,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import "../../style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUser,
  getAllUsers,
  register,
  getRoleUsers,
  updateUser,
  login,
  updateUserStaus,
} from "../../redux/actions/userAction";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@mui/styles";
import "../../Switcher.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Router from "../../routes/route";
import { api } from "../../mockData";
import PersonIcon from "@mui/icons-material/Person";
import { IconBase } from "react-icons/lib";
import { ALL_USERS_RESET } from "../../redux/constants/userConstants";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageTitle from "../common/PageTitle";

const drawerWidth = 240;

// ====table----->

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "45px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-4px !important",
    },
  },
  select: {
    width: "auto",
    fontSize: "12px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectIcon: {
    position: "relative",
    color: "#6EC177",
    fontSize: "14px",
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
});

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto", // Adjust row height to make it more compact
          },
        },
      },
      defaultProps: {
        density: "compact", // Set default density to compact
      },
    },
  },
});

// ===========>
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const permission = [
  {
    dashboard: "Dashboard",
    manage_campaign: "Manage Campaign",
    did_tfn_number: "DID/TFN Number",
    report: "Report",
    call_block: "Call Block",
    active_calls: "Live Calls",
    minutes_log: "Minutes Log",
    live_call_hangup: "Live Call Hangup",
  },
];

const inpVal = {
  userName: "",
  email: "",
  password: "",
  confirmPassword: "",
  phone: "",
  role: "",
  limit: 0,
  amount: 0,
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

function User({ colorThem }) {
  const token = JSON.parse(localStorage.getItem("admin"));
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin"));
  const [validation, setValidation] = useState({
    userName: "",
    // lastname: "",
    email: "",
    // mobile: "",
    password: "",
    confirmPassword: "",
    amount: "",
    status: "",
    role: "",
    service: "",
  });

  const [userActive, setUserActive] = React.useState("");
  const [roleId, setRoleId] = useState(user.user_role === "Reseller" ? 4 : "");
  const [inputValues, setInputValues] = useState(inpVal);
  const [response, setResponse] = useState("");
  const [name, setName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [serviceType, setServiceType] = useState(
    user.user_role === "Reseller" ? ["Manage"] : ["Manage"],
  );
  const [service, setService] = useState([]);
  const [status, setStatus] = useState("");
  const [renewal, setRenewal] = useState(0);
  const [reseller, setReseller] = useState(
    user.user_role === "Reseller" ? user.uid : "",
  );
  const [uId, setUId] = useState(0);
  const [extension, setExtension] = useState("");
  const [attempts, setAttempts] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [radioValue, setRadioValue] = useState("t");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [value, setValue] = useState("t");
  const [searchDestination, setSearchDestination] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [openD, setOpenD] = useState(false); // 👈 added

  // const handleModalView = (row) => {
  //   setSelectedRow(row);   // 👈 data store
  //   setOpenModal(true);    // 👈 modal open
  // };
  const handleCloseModalView = () => {
    setOpenD(false);
    setSelectedRows([]);
  };

  const handleModalView = (row) => {
    setSelectedRows([row]);
    setOpenD(true);

    // dispatch(getCallDetails(row.id)); // 👈 dynamic data
  };

  const handleSelectionChange = (selection) => {
    setSelectedRows(selection);
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // const handlePermissionChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;

  //   const validKeys = Object.keys(permission[0] || {});

  //   setSelectedPermissions(
  //     typeof value === "string"
  //       ? value.split(",").filter((key) => validKeys.includes(key))
  //       : value.filter((key) => validKeys.includes(key))
  //   );
  // };

  const formatDateTimeJSX = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return (
      <span style={{ whiteSpace: "nowrap" }}>
        <span style={{ color: "blue", fontSize: "13px" }}>
          {day}/{month}/{year}
        </span>
      </span>
    );
  };

  const allPermissions = useMemo(() => {
    if (!permission || !Array.isArray(permission) || permission.length === 0)
      return [];
    return Object.entries(permission[0]);
  }, [permission]);

  const filteredPermissions = useMemo(() => {
    return allPermissions.filter(([, label]) =>
      label.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [allPermissions, searchTerm]);

  const handlePermissionChange = (event) => {
    const { value } = event.target;
    setSelectedPermissions(
      typeof value === "string" ? value.split(",") : value,
    );
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setOpenModal("");
    setValidation("");
    setInputValues("");
    setUserActive("");
    setRoleId(user.user_role === "Reseller" ? 4 : "");
    setExtension("");
    setReseller("");
    setSelectedPermissions([]);
    setInputValues({ userName: "", email: "", role: "", limit: "", amount: 0 });
    setAddress("");
  };

  const handleAlertClose = () => setAlertMessage(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllUsers(radioValue));
    dispatch(getRoleUsers());
  }, [radioValue, response]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [name]: value,
    }));
  };
  // ========Edit-button---->
  const [openModal, setOpenModal] = useState(false);

  const handleButtonClick = useCallback(
    (row) => {
      setInputValues({
        userName: row.username,
        email: row.email,
        role: row.role,
        limit: row.extensions_limit,
        amount: row.amount,
      });
      setRoleId(row?.role_id);
      setSelectedPermissions(row?.feature);
      setAddress(row.address);
      setOpenModal(true);
      setStatus(row.status.toString());
      setUId(row.user_id);

      if (row?.service_type !== undefined && row?.service_type !== null) {
        let array = row?.service_type?.split(",");
        setService(array);
      } else {
        setService([]);
      }
      setExtension(row.extension);
      if (row.attempts <= 3) {
        setAttempts(4);
      } else {
        setAttempts(0);
      }
      setPassword(row.password);
      setReseller(row.reseller_id);
      setRenewal(row.account_renewal);
    },
    [setService],
  ); // Memoize event handler

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setInputValues({ userName: "", email: "", role: "", limit: "", amount: 0 });
    setService([]);
    setStatus("");
    setRenewal(0);
    setUId("");
    setRoleId("");
    setExtension("");
    setShowPassword(false);
    setReseller("");
    setSelectedPermissions([]);
    setAddress();
    setSearchTerm("");
  }, [
    setInputValues,
    setService,
    setStatus,
    setRenewal,
    setUId,
    setRoleId,
    setExtension,
    setShowPassword,
    setReseller,
    setAddress,
    setSelectedPermissions,
    setSearchTerm,
  ]);

  // =============Edit-btton-end--->

  const handleChanges = (event) => {
    const {
      target: { value },
    } = event;
    setServiceType(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  const checkValidation = useCallback(() => {
    let errors = { ...validation };
    let isValid = true;
    //first Name validation
    if (!inputValues.userName) {
      errors.userName = "User name is required";
      isValid = false;
    } else {
      errors.userName = "";
    }

    if (!userActive) {
      errors.status = "Field is required";
      isValid = false;
    } else {
      errors.status = "";
    }
    if (!roleId) {
      errors.role = "Role is required";
      isValid = false;
    } else {
      errors.role = "";
    }

    if (serviceType.length === 0) {
      errors.service = "Service is required";
      isValid = false;
    } else {
      errors.service = "";
    }
    const emailCond = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!inputValues.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!inputValues.email.match(emailCond)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    } else {
      errors.email = "";
    }

    //password validation
    const cond1 = "/^(?=.*[a-z]).{6,20}$/";
    const cond2 = "/^(?=.*[A-Z]).{6,20}$/";
    const cond3 = "/^(?=.*[0-9]).{6,20}$/";
    const password = inputValues.password;
    if (!password) {
      errors.password = "password is required";
      isValid = false;
    } else if (password.length < 6) {
      errors.password = "Password must be longer than 6 characters";
      isValid = false;
    } else if (password.length >= 20) {
      errors.password = "Password must shorter than 20 characters";
      isValid = false;
    } else {
      errors.password = "";
    }
    //matchPassword validation
    if (!inputValues.confirmPassword) {
      errors.confirmPassword = "Password confirmation is required";
      isValid = false;
    } else if (inputValues.confirmPassword !== inputValues.password) {
      errors.confirmPassword = "Password does not match";
      isValid = false;
    } else {
      errors.confirmPassword = "";
    }

    setValidation(errors);
    return isValid;
  }, [validation, inputValues, userActive]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const isValid = checkValidation();
      if (isValid) {
        const request = {
          username: inputValues?.userName,
          emailid: inputValues?.email,
          password: inputValues?.password,
          amount: inputValues?.amount,
          address: address,
          role_id: roleId,
          is_active: userActive,
          reseller_id: reseller,
          feature: selectedPermissions,
        };
        dispatch(register(request, setOpen, setInputValues, setResponse));
      }
    },
    [
      checkValidation,
      inputValues,
      setOpen,
      setInputValues,
      setResponse,
      roleId,
      userActive,
      reseller,
      extension,
      selectedPermissions,
      address,
    ],
  ); // Memoize event handler
  const handleUpdate = useCallback(
    (e) => {
      e.preventDefault();
      const request = {
        user_id: uId,
        username: inputValues?.userName,
        emailid: inputValues?.email,
        amount: inputValues?.amount,
        role_id: roleId,
        is_active: status.charAt(0),
        attempts: attempts,
        password: password,
        address: address,
        reseller_id: reseller,
        feature: selectedPermissions,
      };
      dispatch(updateUser(request, setOpenModal, setResponse));
    },
    [
      inputValues,
      roleId,
      service,
      status,
      uId,
      extension,
      password,
      reseller,
      selectedPermissions,
      renewal,
      address,
      setOpenModal,
      setInputValues,
      setService,
      setStatus,
      setUId,
      setResponse,
    ],
  );

  const handleMessage = useCallback((data) => {
    setName(data);
    setAlertMessage(true);
  }, []); // Memoize event handler

  const handleDelete = useCallback(() => {
    dispatch(deleteUser({ username: name }, setResponse));
    setAlertMessage(false);
  }, [dispatch, name, setResponse]); // Memoize event handler

  const handleView = (data) => {
    navigate(Router.ADMIN_VIEW, { state: { data: data } });
  };

  const classes = useStyles();

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    classes: {
      list: classes.list,
      paper: classes.paper,
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    getContentAnchorEl: null,
  };

  const handleLogin = (data) => {
    const value = JSON.stringify({
      username: data.username,
      password: data.password,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${api.dev}/api/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: value,
    };

    axios
      .request(config)
      .then((response) => {
        const values = response?.data;
        if (values?.status === 200) {
          if (values.user_role === "Superadmin") {
            localStorage.setItem("admin", JSON.stringify(values));
            window.open("/admin_portal");
          } else if (values.user_role === "Admin") {
            localStorage.setItem("admin", JSON.stringify(values));
            window.open("/admin_portal");
          } else if (values.user_role === "Reseller") {
            localStorage.setItem("reseller", JSON.stringify(values));
            window.open("/reseller_portal");
          } else if (
            values.user_role !== "Superadmin" &&
            values.user_role !== "Admin" &&
            values.user_role !== "Reseller"
          ) {
            localStorage.setItem(
              `user_${values.user_name}`,
              JSON.stringify(values),
            );
            localStorage.setItem("current_user", values.user_name);
            window.open("/redirect_portal");
          }

          dispatch(login(values));
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        });
      });
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  function stringToColor(string) {
    let hash = 0;

    for (let i = 0; i < string?.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 10) - hash);
    }

    let color = "#";

    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;

      // force light color range
      value = 128 + (value % 128);

      color += ("00" + value.toString(16)).slice(-2);
    }

    return color;
  }

  const baseColumns = [
    {
      field: "login",
      headerName: "User Login",
      width: isXs ? 80 : 80,
      minWidth: 80,
      maxWidth: 80,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      valueGetter: (params) => params.row.login || "", // Ensures value is fetched
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          User Login
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div>
            <Button
              sx={{
                ":hover": {
                  bgcolor: "warning.main",
                  color: "white",
                },
                padding: isMobile ? "0" : "2px",
                py: isMobile ? 1 : 0,
                textTransform: "capitalize",
                fontSize: "calc(0.6rem + 0.2vw)",
                color: "warning.main",
                borderColor: "info.main",
                border: "1px solid #ed6c02",
              }}
              onClick={() => handleLogin(params.row)}
            >
              Login
            </Button>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      sortable: false,
      disableColumnMenu: true,
      width: isXs ? 55 : 60,
      minWidth: 55,
      maxWidth: 60,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Action
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {user.user_role === "Reseller" ? (
              <>
                {" "}
                <Tooltip title="Edit">
                  <IconButton onClick={() => handleButtonClick(params.row)}>
                    <Edit
                      index={params.row.id}
                      style={{
                        cursor: "pointer",
                        color: "#42765f",
                        fontSize: isMobile ? "20px" : "25x",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title="Edit">
                  <IconButton onClick={() => handleButtonClick(params.row)}>
                    <Edit
                      index={params.row.id}
                      style={{
                        cursor: "pointer",
                        color: "#42765f",
                        fontSize: isMobile ? "20px" : "35x",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title="View">
                 
                  <IconButton onClick={() => handleModalView(params.row)}>
                    <Visibility
                      style={{
                        cursor: "pointer",
                        color: "#f5751d",
                        fontSize: isMobile ? "12px" : "18px",
                      }}
                    />
                  </IconButton>
                </Tooltip> */}
              </>
            )}
          </div>
        );
      },
    },
    {
      field: "username",
      headerName: "User Name",
      width: isXs ? 180 : 190,
      minWidth: 180,
      flex: 1,
      maxWidth: 190,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "Name" : "User Name"}
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className=" user_bdr d-flex justify-content-between align-items-center">
            <Tooltip title="View">
              <Box
                className="user_img"
                // onClick={() => handleView(params.row.user_id)}
                onClick={() => handleModalView(params.row)}

                
                sx={{ cursor: "pointer" }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontSize: "calc(0.6rem + 0.2vw)" }}
                >
                  <IconBase
                    style={{
                      fontSize: "20px",
                      color: "#f5751d",
                      marginRight: "5px",
                    }}
                  >
                    <PersonIcon />
                  </IconBase>
                  {params.row.username}
                </Typography>
              </Box>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "did_count",
      headerName: "No. of DID",
      width: isXs ? 45 : 60,
      minWidth: 45,
      maxWidth: 60,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "DID" : "No. of DID"}
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.3vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },
    // {
    //   field: "subscriber_count",
    //   headerName: "No. of Extension",
    //   width: 150,
    //   headerClassName: "custom-header",
    //   headerAlign: "center",
    //   align: "center",
    // },
    // {
    //   field: "reseller_id",
    //   headerName: "Reseller",
    //   width: isXs ? 65 : 70,
    //   minWidth: 65,
    //   maxWidth: 70,
    //   headerClassName: "custom-header",
    //   headerAlign: "left",
    //   align: "left",
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         color: "white !important",
    //       }}
    //     >
    //       Reseller
    //     </Typography>
    //   ),
    //   renderCell: (params) => {
    //     return (
    //       <div className=" user_bdr d-flex justify-content-between align-items-center">
    //         {state?.allUsers?.users?.map((name, index) => {
    //           if (name?.role === "Reseller") {
    //             return (
    //               <span
    //                 key={index}
    //                 style={{
    //                   textTransform: "capitalize",
    //                   fontSize: "calc(0.6rem + 0.2vw)",
    //                 }}
    //               >
    //                 {name.id === params.row.reseller_id ? (
    //                   <>{name.username}</>
    //                 ) : (
    //                   <></>
    //                 )}
    //               </span>
    //             );
    //           }
    //         })}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "email",
      headerName: "Email",
      width: isXs ? 250 : 300,
      minWidth: 250,
      flex: 1,
      maxWidth: 300,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Email
        </Typography>
      ),
      renderCell: (params) => (
        <Tooltip
          title={`Address: ${params.row.address}`}
          style={{ fontSize: "0.875rem" }}
        >
          <Typography
            variant="body2"
            sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },

    {
      field: "role",
      headerName: "Role",
      width: isXs ? 80 : 100,
      minWidth: 80,
      maxWidth: 100,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Role
        </Typography>
      ),
      renderCell: (params) => {
        const role = params.row.role;

        // Predefined colors for main roles
        const roleColors = {
          Superadmin: "white",
          Admin: "#D6D8DB",
          Reseller: "#C3E6CB",
        };

        // If role not in predefined, generate dynamic color
        const bgColor = roleColors[role] || stringToColor(role); // Generate color for dynamic roles

        return (
          <div className="d-flex justify-content-between align-items-center">
            <div
              className="role_box"
              style={{
                color: "black",
                background: bgColor,
                padding: isMobile ? "5px" : "7px",
                borderRadius: "5px",
                fontSize: "calc(0.6rem + 0.2vw)",
                textTransform: "capitalize",
              }}
            >
              {role}
            </div>
          </div>
        );
      },
    },

    {
      field: "created_date",
      headerName: "Date",
      headerClassName: "custom-header",
      width: isXs ? 75 : 80,
      minWidth: 75,
      maxWidth: 80,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Date
        </Typography>
      ),
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1; // Month starts from 0
          var year = date.getUTCFullYear();

          // Formatting single-digit day/month with leading zero if needed
          day = (day < 10 ? "0" : "") + day;
          month = (month < 10 ? "0" : "") + month;
          return (
            <>
              <span style={{ color: "blue", fontSize: "calc(0.6rem + 0.2vw)" }}>
                {day}/{month}/{year}
              </span>
            </>
          );
        }
      },
    },

    // {
    //   field: "amount",
    //   headerName: "Amount",
    //   headerClassName: "custom-header",
    //   width: isXs ? 75 : 80,
    //   minWidth: 75,
    //   maxWidth: 80,
    //   headerAlign: "left",
    //   align: "left",
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         color: "white !important",
    //       }}
    //     >
    //       Amount
    //     </Typography>
    //   ),
    //   renderCell: (params) => {
    //     return (
    //       <div className="d-flex justify-content-between align-items-center">
    //         <div
    //           style={{
    //             color: "blueviolet",
    //             padding: isMobile ? "4px" : "7px",
    //             borderRadius: "5px",
    //             fontSize: "calc(0.6rem + 0.2vw)",
    //             textTransform: "capitalize",
    //           }}
    //         >
    //           {`$${params.row.amount}`}
    //         </div>
    //       </div>
    //     );
    //   },
    // },

    {
      field: "attempts",
      headerName: "Account",
      headerClassName: "custom-header",
      width: isXs ? 75 : 80,
      minWidth: 75,
      maxWidth: 80,
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Account
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.attempts >= 3 ? (
              <>
                <div
                  style={{
                    // color: "white",
                    color: "red",
                    padding: isMobile ? "4px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                  }}
                >
                  Locked
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "green",
                    padding: isMobile ? "4px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                  }}
                >
                  Unlocked
                </div>
              </>
            )}
          </div>
        );
      },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: isXs ? 100 : 100,
    //   minWidth: 70,
    //   maxWidth: 100,
    //   headerClassName: "custom-header",
    //   headerAlign: "left",
    //   align: "left",
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         color: "white !important",
    //       }}
    //     >
    //       Status
    //     </Typography>
    //   ),
    //   renderCell: (params) => {
    //     return (
    //       <div className="d-flex justify-content-between align-items-center">
    //         {params.row.status === "t" ? (
    //           <>
    //             <div
    //               style={{
    //                 color: "white",
    //                 background: "green",
    //                 padding: isMobile ? "5px" : "7px",
    //                 borderRadius: "5px",
    //                 fontSize: "calc(0.6rem + 0.2vw)",
    //                 textTransform: "capitalize",
    //                 textAlign: "center",
    //               }}
    //             >
    //               active
    //             </div>
    //           </>
    //         ) : params.row.status === "s" ? (
    //           <>
    //             <div
    //               style={{
    //                 color: "black",
    //                 background: "yellow",
    //                 padding: isMobile ? "5px" : "7px",
    //                 borderRadius: "5px",
    //                 fontSize: "calc(0.6rem + 0.2vw)",
    //                 textTransform: "capitalize",
    //               }}
    //             >
    //               Suspend
    //             </div>
    //           </>
    //         ) : params.row.status === "r" ? (
    //           <>
    //             <div
    //               style={{
    //                 color: "black",
    //                 background: "rgba(8, 206, 8, 0.74)",
    //                 padding: "7px",
    //                 borderRadius: "5px",
    //                 fontSize: "12px",
    //                 textTransform: "capitalize",
    //               }}
    //             >
    //               Renewal
    //             </div>
    //           </>
    //         ) : params.row.status === "n" ? (
    //           <>
    //             <div
    //               style={{
    //                 color: "black",
    //                 background: "rgba(255, 0, 0, 0.47)",
    //                 padding: "7px",
    //                 borderRadius: "5px",
    //                 fontSize: "12px",
    //                 textTransform: "capitalize",
    //               }}
    //             >
    //               Not Renewal
    //             </div>
    //           </>
    //         ) : (
    //           <>
    //             <div
    //               style={{
    //                 color: "white",
    //                 background: "red",
    //                 padding: isMobile ? "5px" : "7px",
    //                 borderRadius: "5px",
    //                 fontSize: "calc(0.6rem + 0.2vw)",
    //                 textTransform: "capitalize",
    //               }}
    //             >
    //               Deactive
    //             </div>
    //           </>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "status_changed_by",
    //   headerName: "Changed By",
    //   flex: 1,
    //   minWidth: 180, // 👈 important for header/content balance
    //   headerClassName: "custom-header",
    //   headerAlign: "left",
    //   align: "left",

    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{
    //         fontSize: "calc(0.6rem + 0.2vw)",
    //         fontWeight: "bold",
    //         whiteSpace: "nowrap",
    //       }}
    //     >
    //       Changed By
    //     </Typography>
    //   ),

    //   renderCell: (params) => {
    //     const roleUser = state?.roles?.users?.find(
    //       (u) => u.id === params.row.status_role_id,
    //     );

    //     return (
    //       <Typography
    //         variant="body2"
    //         sx={{
    //           fontSize: "calc(0.6rem + 0.2vw)",
    //           whiteSpace: "nowrap",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //         }}
    //       >
    //         {params.row.status_changed_by}
    //         {roleUser ? ` (${roleUser.name})` : ""}
    //       </Typography>
    //     );
    //   },
    // },
  ];

  const suspendDateColumn = {
    //-----Suspend Date-------
    field: "suspended_at",
    headerName: "Sus Date",
    width: 100,
    headerClassName: "custom-header",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      if (params.value !== null) {
        const date = new Date(params.value);
        var day = date.getUTCDate();
        var month = date.getUTCMonth() + 1; // Month starts from 0
        var year = date.getUTCFullYear();

        // Formatting single-digit day/month with leading zero if needed
        day = (day < 10 ? "0" : "") + day;
        month = (month < 10 ? "0" : "") + month;

        // Formatting single-digit hours/minutes/seconds with leading zero if needed

        var formattedDate = day + "/" + month + "/" + year + " ";
        return (
          <>
            <span style={{ color: "blue" }}>
              {day}/{month}/{year}
            </span>
          </>
        );
      }
    },
  };

  const statusColumn = {
    field: "status",
    headerName: "Status",
    width: isXs ? 100 : 100,
    minWidth: 70,
    maxWidth: 100,
    headerClassName: "custom-header",
    headerAlign: "left",
    align: "left",
    renderHeader: () => (
      <Typography
        variant="body2"
        sx={{
          fontSize: "calc(0.6rem + 0.2vw)",
          fontWeight: "bold",
          color: "white !important",
        }}
      >
        Status
      </Typography>
    ),
    renderCell: (params) => {
      return (
        <div className="d-flex justify-content-between align-items-center">
          {params.row.status === "t" ? (
            <>
              <div
                style={{
                  color: "white",
                  background: "green",
                  padding: isMobile ? "5px" : "7px",
                  borderRadius: "5px",
                  fontSize: "calc(0.6rem + 0.2vw)",
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                active
              </div>
            </>
          ) : params.row.status === "s" ? (
            <>
              <div
                style={{
                  color: "black",
                  background: "yellow",
                  padding: isMobile ? "5px" : "7px",
                  borderRadius: "5px",
                  fontSize: "calc(0.6rem + 0.2vw)",
                  textTransform: "capitalize",
                }}
              >
                Suspend
              </div>
            </>
          ) : params.row.status === "r" ? (
            <>
              <div
                style={{
                  color: "black",
                  background: "rgba(8, 206, 8, 0.74)",
                  padding: "7px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Renewal
              </div>
            </>
          ) : params.row.status === "n" ? (
            <>
              <div
                style={{
                  color: "black",
                  background: "rgba(255, 0, 0, 0.47)",
                  padding: "7px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Not Renewal
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  color: "white",
                  background: "red",
                  padding: isMobile ? "5px" : "7px",
                  borderRadius: "5px",
                  fontSize: "calc(0.6rem + 0.2vw)",
                  textTransform: "capitalize",
                }}
              >
                Deactive
              </div>
            </>
          )}
        </div>
      );
    },
  };

  const columns = useMemo(() => {
    if (radioValue === "") {
      // Sirf "All" par status column add karo
      return [...baseColumns, statusColumn];
    }

    if (radioValue === "s") {
      // Sirf "All" par status column add karo
      return [...baseColumns, suspendDateColumn];
    }
    return baseColumns; // baaki sab par status hide
  }, [radioValue, baseColumns]);

  // useEffect(() => {
  //   if (uId !== "") {
  //     let config = {
  //       method: "get",
  //       maxBodyLength: Infinity,
  //       url: `${api.dev}/api/getuserextensions?user_id=${uId}`,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token.access_token} `,
  //       },
  //     };
  //     axios
  //       .request(config)
  //       .then((response) => {
  //         setExtensionNumber(response?.data);
  //       })
  //       .catch((error) => {
  //       });
  //   }
  // }, [uId]);

  useEffect(() => {
    // Display error toast only if an error occurred and it hasn't been displayed yet
    if (state?.allUsers?.error) {
      toast.error(state.allUsers.error, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
      // Dispatch action to reset state
      dispatch({ type: ALL_USERS_RESET });
    }

    // Navigate to login page after state reset and error toast display
    if (state?.allUsers?.error && state?.allUsers?.users.length === 0) {
      //   localStorage.removeItem("theme-color");
      //   localStorage.removeItem("admin");
      //  // Immediate redirect to login page
      //  window.location.replace("/login");
    }
  }, [state?.allUsers?.error, state?.allUsers?.users.length, dispatch]);

  const rows = useMemo(() => {
    const calculatedRows = [];
    state?.allUsers?.users &&
      state?.allUsers?.users?.forEach((item, index) => {
        const createdDate = new Date(item.created_date).toISOString();
        calculatedRows.push({
          id: index + 1,
          user_id: item.id,
          email: item.email,
          service_type: item.service_type,
          name: item.name,
          phone: item.phone,
          cc: item.cc,
          role: item.role,
          role_id: item.role_id,
          status: item.is_active,
          username: item.username,
          password: item.password,
          created_date: createdDate,
          extensions_limit: item.extensions_limit,
          extension: item.extension,
          attempts: item.attempts,
          reseller_id: item.reseller_id,
          status_changed_by: item.status_changed_by,
          status_role_id: item.status_role_id,
          did_count: item.did_count,
          subscriber_count: item.subscriber_count,
          feature: item.feature,
          account_renewal: item.account_renewal,
          amount: item.amount,
          address: item.address,
          suspended_at: item.suspended_at,
        });
      });
    return calculatedRows;
  }, [state?.allUsers?.users]);

  const selectedCallerDataSet = new Set(); // Using Set to avoid duplicates

  selectedRows?.forEach((id) => {
    const selectedRow = rows.find((row) => row.id === id);
    if (selectedRow) {
      selectedCallerDataSet.add(selectedRow.user_id); // Add only did_id
    }
  });

  const selectedCallerData = Array.from(selectedCallerDataSet); // Convert to comma-separated string

  const handleUpdateStatus = useCallback(() => {
    const request = {
      id: selectedCallerData,
      is_active: value,
    };
    dispatch(updateUserStaus(request, setResponse));
  }, [selectedCallerData, value, dispatch, setResponse]); // Memoize event handler

  // const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  //   "& .highlighted-renewal": {
  //     backgroundColor: "rgba(0, 255, 0, 0.2) !important", // Blue for renewal
  //   },
  //   "& .highlighted-not-renewal": {
  //     backgroundColor: "rgba(255, 0, 0, 0.2) !important", // Gray for not renewal
  //   },
  // }));

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <Dialog
              className="custom_dailog_box_user"
              open={openModal}
              onClose={handleCloseModal}
              sx={{ textAlign: "center", borderRadius: "10px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  paddingTop: "10px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  className="modal_heading"
                  sx={{
                    color: "#133325",
                    fontWeight: "600",
                    width: "500px",
                  }}
                >
                  User Edit
                </Typography>
                <IconButton
                  className="close_icon"
                  onClick={handleCloseModal}
                  sx={{ float: "inline-end" }}
                >
                  <Close />
                </IconButton>
              </Box>

              <DialogContent>
                <form
                  style={{
                    textAlign: "left",
                    paddingTop: "10px",
                    width: "auto",
                  }}
                >
                  <Grid container spacing={1.5}>
                    {/* Email */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Email Id"
                        name="email"
                        value={inputValues?.email || ""}
                        onChange={handleChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MailIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {/* Username */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="User Name"
                        name="userName"
                        value={inputValues?.userName || ""}
                        onChange={handleChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    {/* Password */}
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        label="Change Password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              sx={{ cursor: "pointer" }}
                              onClick={handlePasswordVisibility}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    {/* Amount */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Amount"
                        name="amount"
                        value={inputValues?.amount || ""}
                        onChange={handleChange}
                      />
                      {validation.amount && (
                        <p
                          style={{
                            color: "red",
                            textAlign: "left",
                            margin: "4px 0 0",
                          }}
                        >
                          {validation.amount}
                        </p>
                      )}
                    </Grid>

                    {/* Role */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel>Role</InputLabel>
                        <Select
                          style={{ textAlign: "left" }}
                          label="Role"
                          value={roleId}
                          onChange={(e) => setRoleId(e.target.value)}
                          disabled={user.user_role === "Reseller"}
                        >
                          {state?.roles?.users?.map((item, index) => (
                            <MenuItem key={index} value={item?.id}>
                              {item?.name.toLowerCase()}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Status */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                          style={{ textAlign: "left" }}
                          label="Status"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <MenuItem value={"t"}>Active</MenuItem>
                          <MenuItem value={"f"}>Deactive</MenuItem>
                          <MenuItem value={"s"}>Suspend</MenuItem>
                          <MenuItem value={"r"}>Renewal</MenuItem>
                          <MenuItem value={"n"}>Not renewal</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Account */}
                    {user.user_role !== "Reseller" && (
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Account</InputLabel>
                          <Select
                            style={{ textAlign: "left" }}
                            label="Account"
                            value={attempts}
                            onChange={(e) => setAttempts(e.target.value)}
                          >
                            <MenuItem value={4}>Unlocked</MenuItem>
                            <MenuItem value={0}>Locked</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    {/* Reseller */}
                    {user.user_role !== "Reseller" && (
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                          <InputLabel>Reseller</InputLabel>
                          <Select
                            style={{ textAlign: "left" }}
                            label="Reseller"
                            value={reseller}
                            onChange={(e) => setReseller(e.target.value)}
                          >
                            {state?.allUsers?.users?.map((name, index) =>
                              name?.role === "Reseller" ? (
                                <MenuItem key={index} value={name?.id}>
                                  {name.username}
                                </MenuItem>
                              ) : null,
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                    {/* Permissions */}
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Enable Feature</InputLabel>
                        <Select
                          style={{ textAlign: "left" }}
                          multiple
                          value={selectedPermissions}
                          onChange={handlePermissionChange}
                          input={<OutlinedInput label="Enable Feature" />}
                          renderValue={(selected) =>
                            selected.map((k) => permission[0][k]).join(", ")
                          }
                        >
                          {filteredPermissions.map(([key, label]) => (
                            <MenuItem key={key} value={key}>
                              <Checkbox
                                checked={selectedPermissions.includes(key)}
                              />
                              <ListItemText primary={label} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Address */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Address"
                        multiline
                        rows={2}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                </form>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "20px",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "16px !impotant",
                    background:
                      "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                    marginTop: "20px",
                    padding: "10px 20px !important",
                    textTransform: "capitalize !important",
                  }}
                  className="all_button_clr"
                  color="info"
                  onClick={handleCloseModal}
                  autoFocus
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "20px",
                    fontSize: "16px !impotant",
                    background: "#092b5f",

                    marginLeft: "0px !important",
                    padding: "10px 20px !important",
                    textTransform: "capitalize !important",
                  }}
                  className="all_button_clr"
                  color="error"
                  onClick={handleUpdate}
                >
                  Update
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={alertMessage}
              onClose={handleAlertClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={{ textAlign: "center" }}
              //className="bg_imagess"
            >
              <DialogTitle
                className="modal_heading"
                id="alert-dialog-title"
                sx={{ color: "#07285d", fontWeight: "600" }}
              >
                {"Delete Confirmation"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  sx={{ paddingBottom: "0px !important" }}
                >
                  Are you sure you want to delete {name} ?
                </DialogContentText>
              </DialogContent>
              <DialogActions
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "20px",
                  gap: { xs: "0px", md: "15px" },
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    background:
                      "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                  }}
                  className="all_button_clr"
                  color="info"
                  onClick={handleAlertClose}
                  autoFocus
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="all_button_clr"
                  color="error"
                  onClick={handleDelete}
                  startIcon={<DeleteIcon />}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            {/* ========== */}
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div
                        className="cntnt_title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <PageTitle title="User" />

                          {/* <p>Add, edit, delete, and search users.</p> */}
                        </div>
                        {/*====================== Add-Button ============================ */}
                        {user.user_role === "Reseller" ? (
                          <>
                            <IconButton
                              className="all_button_clr"
                              onClick={handleOpen}
                            >
                              Add <AddOutlinedIcon />
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              className="all_button_clr"
                              sx={{
                                fontSize: "15px",
                                borderRadius: "5px",
                                border: "none",
                                color: "#fff",
                                px: 4,
                                textTransform: "capitalize",
                                height: "35px",
                                width: "90px",
                                minWidth: "90px",
                                flexShrink: 0,
                                display: "inline-flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                position: "relative",
                                right: "-15px",
                              }}
                              onClick={handleOpen}
                            >
                              Add <AddOutlinedIcon />
                            </IconButton>
                          </>
                        )}

                        {/* -----   Add User Modal Start   ----- */}

                        <Dialog
                          className="custom_dailog_box_user"
                          open={open}
                          onClose={handleClose}
                          sx={{ textAlign: "center", borderRadius: "10px" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              paddingTop: "10px",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              className="modal_heading"
                              sx={{
                                color: "#133325",
                                fontWeight: "600",
                                width: "500px",
                              }}
                            >
                              Add User
                            </Typography>
                            <IconButton
                              className="close_icon"
                              onClick={handleClose}
                              sx={{ float: "inline-end" }}
                            >
                              <Close />
                            </IconButton>
                          </Box>

                          <DialogContent>
                            <form
                              style={{
                                textAlign: "left",
                                paddingTop: "10px",
                                padding: "5px",
                              }}
                            >
                              <Grid container spacing={1.5}>
                                {/* USER NAME */}
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    label="User Name"
                                    name="userName"
                                    autoComplete="off"
                                    value={inputValues?.userName || ""}
                                    onChange={handleChange}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <AccountCircle />
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                  {validation.userName && (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "left",
                                      }}
                                    >
                                      {validation.userName}
                                    </p>
                                  )}
                                </Grid>

                                {/* EMAIL */}
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    label="Email Id"
                                    name="email"
                                    value={inputValues?.email || ""}
                                    onChange={handleChange}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <MailIcon />
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                  {validation.email && (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "left",
                                      }}
                                    >
                                      {validation.email}
                                    </p>
                                  )}
                                </Grid>

                                {/* PASSWORD */}
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    fullWidth
                                    type="password"
                                    label="Password"
                                    autoComplete="new-password"
                                    name="password"
                                    value={inputValues?.password || ""}
                                    onChange={handleChange}
                                  />
                                  {validation.password && (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "left",
                                      }}
                                    >
                                      {validation.password}
                                    </p>
                                  )}
                                </Grid>

                                {/* CONFIRM PASSWORD */}
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    fullWidth
                                    type="password"
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    value={inputValues?.confirmPassword || ""}
                                    onChange={handleChange}
                                  />
                                  {validation.confirmPassword && (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "left",
                                      }}
                                    >
                                      {validation.confirmPassword}
                                    </p>
                                  )}
                                </Grid>

                                {/* AMOUNT */}
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label="Amount"
                                    name="amount"
                                    value={inputValues?.amount || ""}
                                    onChange={handleChange}
                                  />
                                </Grid>

                                {/* PERMISSION */}
                                <Grid item xs={12} md={6}>
                                  <FormControl fullWidth>
                                    <InputLabel>Enable Feature</InputLabel>
                                    <Select
                                      multiple
                                      value={selectedPermissions}
                                      onChange={handlePermissionChange}
                                      input={
                                        <OutlinedInput label="Enable Feature" />
                                      }
                                      renderValue={(selected) =>
                                        selected
                                          .map((key) => permission[0][key])
                                          .join(", ")
                                      }
                                    >
                                      {Object.entries(permission[0]).map(
                                        ([key, value]) => (
                                          <MenuItem key={key} value={key}>
                                            <Checkbox
                                              checked={
                                                selectedPermissions.indexOf(
                                                  key,
                                                ) > -1
                                              }
                                            />
                                            <ListItemText primary={value} />
                                          </MenuItem>
                                        ),
                                      )}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {/* ROLE */}
                                {user.user_role !== "Reseller" && (
                                  <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                      <InputLabel>Role</InputLabel>
                                      <Select
                                        value={roleId}
                                        label="Role"
                                        onChange={(e) =>
                                          setRoleId(e.target.value)
                                        }
                                      >
                                        {state?.roles?.users?.map(
                                          (item, index) => (
                                            <MenuItem
                                              key={index}
                                              value={item?.id}
                                            >
                                              {item?.name.toLowerCase()}
                                            </MenuItem>
                                          ),
                                        )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                )}

                                {/* STATUS */}
                                <Grid item xs={12} md={6}>
                                  <FormControl fullWidth>
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                      value={userActive}
                                      label="Status"
                                      onChange={(e) =>
                                        setUserActive(e.target.value)
                                      }
                                    >
                                      <MenuItem value={"t"}>Active</MenuItem>
                                      <MenuItem value={"f"}>Deactive</MenuItem>
                                      <MenuItem value={"s"}>Suspend</MenuItem>
                                      <MenuItem value={"r"}>Renewal</MenuItem>
                                      <MenuItem value={"n"}>
                                        Not renewal
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {/* RESELLER */}
                                {roleId === 4 && (
                                  <Grid item xs={12}>
                                    <FormControl fullWidth>
                                      <InputLabel>Reseller</InputLabel>
                                      <Select
                                        value={reseller}
                                        label="Reseller"
                                        onChange={(e) =>
                                          setReseller(e.target.value)
                                        }
                                      >
                                        {state?.allUsers?.users?.map(
                                          (name, index) => {
                                            if (name?.role === "Reseller") {
                                              return (
                                                <MenuItem
                                                  key={index}
                                                  value={name?.id}
                                                >
                                                  {name.username}
                                                </MenuItem>
                                              );
                                            }
                                          },
                                        )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                )}

                                {/* ADDRESS FULL WIDTH */}
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    label="Address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    multiline
                                    rows={2}
                                  />
                                </Grid>
                              </Grid>
                            </form>
                          </DialogContent>
                          <DialogActions
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              paddingBottom: "20px",
                            }}
                          >
                            <Button
                              variant="contained"
                              className="all_cancel_btn"
                              color="primary"
                              sx={{
                                fontSize: "16px !impotant",
                                background:
                                  "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                // marginTop: "20px",
                                padding: "10px 20px !important",
                                textTransform: "capitalize !important",
                              }}
                              onClick={handleClose}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              className="all_button_clr"
                              color="primary"
                              sx={{
                                fontSize: "16px !impotant",
                                background: "#092b5f",

                                marginLeft: "10px !important",
                                padding: "10px 20px !important",
                                textTransform: "capitalize !important",
                              }}
                              onClick={handleSubmit}
                            >
                              save
                            </Button>
                          </DialogActions>
                        </Dialog>

                        {/* -----   Add User Modal End   ----- */}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <FormControl>
                    {/* <FormLabel id="demo-row-radio-buttons-group-label">Live Calls</FormLabel> */}
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={radioValue} // Bind the selected value to state
                      onChange={(e) => setRadioValue(e.target.value)} // Handle change event
                    >
                      <FormControlLabel
                        value=""
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="t"
                        control={<Radio />}
                        label="Active"
                      />
                      <FormControlLabel
                        value="f"
                        control={<Radio />}
                        label="Deactivated"
                      />
                      <FormControlLabel
                        value="s"
                        control={<Radio />}
                        label="Suspended"
                      />
                      <FormControlLabel
                        value={"r"}
                        control={<Radio />}
                        label="Renewal"
                      />
                      <FormControlLabel
                        value={"n"}
                        control={<Radio />}
                        label="Not Renewal"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                <Grid container>
                  <Grid item xs={12} sm={12} md={4} className="userbtnn">
                    <Box sx={{ display: selectedRows[0] ? "block" : "none" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ flexGrow: 1, mr: 2 }}>
                          <Select
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            fullWidth
                            sx={{
                              mb: 1,
                              height: "35px", // Match button height
                            }}
                          >
                            <MenuItem value="t">Active</MenuItem>
                            <MenuItem value="f">Deactivated</MenuItem>
                            <MenuItem value="s">Suspended</MenuItem>
                            <MenuItem value="r">Renewal</MenuItem>
                            <MenuItem value="n">Not Renewal</MenuItem>
                          </Select>
                        </Box>

                        <Box>
                          <IconButton
                            className="all_button_clr"
                            sx={{
                              position: "relative",
                              top: "-5px",
                              fontSize: "15px",
                              borderRadius: "5px",
                              color: "#fff",
                              px: 4,
                              textTransform: "capitalize",
                              height: "35px",
                              width: "90px",
                              minWidth: "90px",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "primary.main", // Add proper color
                              "&:hover": {
                                backgroundColor: "primary.dark", // Add hover effect
                              },
                            }}
                            onClick={handleUpdateStatus}
                          >
                            Submit
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
                {state?.allUsers?.loading === true ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "90%",
                        marginTop: "9rem !important",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  </>
                ) : (
                  <>
                    <ThemeProvider theme={theme}>
                      <div style={{ height: "100%", width: "100%" }}>
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          density="compact"
                          checkboxSelection
                          disableRowSelectionOnClick
                          rowSelectionModel={selectedRows}
                          onRowSelectionModelChange={handleSelectionChange}
                          components={{ Toolbar: GridToolbar }}
                          slots={{
                            toolbar: CustomToolbar,
                          }}
                          autoHeight // Automatically adjust the height to fit all rows
                        />
                      </div>
                    </ThemeProvider>
                  </>
                )}

                {/* user data view modal */}

                <Dialog
                  open={openD}
                  onClose={handleCloseModalView}
                  maxWidth="md"
                  fullWidth
                 >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      justifyContent: "space-between",
                      gap: 2,
                      p: { xs: "10px 12px", sm: "2px 20px" },
                    }}
                  >
                    {/* Title */}
                    <Typography
                      className="extension_title"
                      sx={{
                        color: "#0a140e",
                        paddingTop: "15px",
                        fontSize: { xs: 18, sm: 20 },
                        fontWeight: 600,
                        textAlign: { xs: "center", sm: "left" },
                        width: "100%",
                      }}
                    >
                      User Details
                    </Typography>

                    {/* Actions */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: {
                          xs: "space-between",
                          sm: "flex-end",
                        },
                          paddingTop: "15px",
                        alignItems: "center",
                        width: { xs: "100%", sm: "auto" },
                        gap: 1,
                        paddingBottom: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleCloseModalView}
                        className="close_icon"
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </Box>

                  <DialogContent >
                    <>
                      {/* 🔹 Summary Section */}

                      <Grid container spacing={1} style={{paddingBottom: "20px",}}>
                        {[
                          // COLUMN 1

                          [
                            {
                              label: "User Name",
                              value: selectedRows[0]?.username,
                            },
                            {
                              label: "No. of DID",
                              value: selectedRows[0]?.did_count,
                            },

                            {
                              label: "Reseller",
                              value: (() => {
                                const reseller = state?.allUsers?.users?.find(
                                  (user) =>
                                    user?.role === "Reseller" &&
                                    user?.id === selectedRows[0]?.reseller_id,
                                );

                                return (
                                  <span style={{ fontWeight: 500 }}>
                                    {reseller?.username || "-"}
                                  </span>
                                );
                              })(),
                            },
                            {
                              label: "Email",
                              value: selectedRows[0]?.email,
                            },
                            {
                              label: "Role",
                              value: (() => {
                                const role = selectedRows[0]?.role;

                                const roleColors = {
                                  Superadmin: "#f2f2f2",
                                  Admin: "#D6D8DB",
                                  Reseller: "#C3E6CB",
                                };

                                const bgColor =
                                  roleColors[role] || stringToColor(role);

                                return (
                                  <span
                                    style={{
                                      backgroundColor: bgColor,
                                      padding: "4px 8px",
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      display: "inline-block",
                                    }}
                                  >
                                    {role || "-"}
                                  </span>
                                );
                              })(),
                            },
                          ],

                          // COLUMN 2
                          [
                            {
                              label: "Date",
                              value: formatDateTimeJSX(
                                selectedRows[0]?.created_date,
                              ),
                            },
                            {
                              label: "Amount",
                              value: (
                                <div style={{ color: "blueviolet" }}>
                                  ${selectedRows[0]?.amount || 0}
                                </div>
                              ),
                            },
                            {
                              label: "Account",
                              value:
                                selectedRows[0]?.attempts >= 3 ? (
                                  <div
                                    style={{
                                      // color: "white",
                                      color: "red",
                                      padding: isMobile ? "4px" : "7px",
                                      borderRadius: "5px",
                                      fontSize: "calc(0.6rem + 0.2vw)",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    Locked
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      color: "green",
                                      padding: isMobile ? "4px" : "7px",
                                      borderRadius: "5px",
                                      fontSize: "calc(0.6rem + 0.2vw)",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    Unlocked
                                  </div>
                                ),
                            },
                            {
                              label: "Changed By",
                              value: selectedRows[0]?.status_changed_by,
                            },
                          ],
                        ].map((column, colIndex) => (
                          <Grid item xs={12} md={6} key={colIndex}>
                            <table
                              className="table mb-0 align-middle"
                              style={{
                                width: "100%",
                                tableLayout: "fixed", // ✅ IMPORTANT
                              }}
                             >
                              <tbody>
                                {column.map((row, rowIndex) => (
                                  <tr key={rowIndex}>
                                    {/* ===== LABEL TD (40%) ===== */}
                                    <td
                                      style={{
                                        width: "30%",
                                        border: "none",
                                        fontSize: "13px",
                                        padding: "7px",
                                        fontWeight: 700,
                                        color: "#07285d",
                                        wordBreak: "break-word",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {row.label} <span className="ms-2">:</span>
                                    </td>

                                    {/* ===== VALUE TD (60%) ===== */}
                                    <td
                                      style={{
                                        width: "70%",
                                        border: "none",
                                        fontSize: "13px",
                                        padding: "6px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {row.value}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Grid>
                        ))}
                      </Grid>

                      {/* 🔹 Detail Table */}

                      {/* 🔹 Recording */}
                    </>
                  </DialogContent>
                </Dialog>
              </div>
            </div>

            {/* ========== */}
          </Box>
        </div>
      </div>
    </>
  );
}

export default User;
